import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { NavMainNode } from '@core/models/nav-main.model';

@Injectable()
export class NavMainService {
  constructor(private http: HttpClient) {}

  getAll(): Observable<NavMainNode[]> {
    const endPoint = 'profile/menu';

    return this.http.get<NavMainNode[]>(endPoint);
  }
}
